module.exports = __webpack_public_path__ + "static/media/reproductive_icon_grey.8673fbce.svg";